import { authManager } from '../auth-manager.js';

export function renderManualView(container, syncManager) {
  const isAuthenticated = authManager.isAuthenticated();

  container.innerHTML = `
    <div class="manual-page-root" style="min-height: 100vh; padding-bottom: 5rem; color: var(--text-main);">
      ${!isAuthenticated ? `
        <!-- Navbar (identica a pagina inicial) -->
        <header class="landing-navbar">
          <div class="landing-nav-container">
            <a href="#landing" class="landing-brand">
              <img src="/favicon.svg" alt="NF Tracker Logo" class="landing-brand-logo" />
              <span class="landing-brand-name">NF Tracker</span>
              <span class="landing-brand-badge">Beta</span>
            </a>
            <a href="#login" class="landing-btn-primary">
              Entrar
            </a>
          </div>
        </header>
      ` : ''}

      <!-- Main Content Container -->
      <main style="max-width: 860px; margin: 0 auto; padding: 1.5rem 1rem;">
        
        <!-- Hero Card -->
        <section class="glass-panel mb-lg" style="background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.08) 100%); border: 1px solid var(--border-color); border-radius: 1.25rem; padding: 1.75rem 1.25rem; text-align: center;">
          <div style="display: inline-flex; align-items: center; gap: 0.4rem; background: var(--bg-surface); color: var(--color-info, #3B82F6); font-weight: 800; font-size: 0.75rem; padding: 0.3rem 0.85rem; border-radius: var(--radius-pill); border: 1px solid var(--border-color); box-shadow: var(--shadow-card); margin-bottom: 0.85rem;">
            <span class="material-symbols-outlined" style="font-size: 16px;">menu_book</span>
            <span>Aprenda em 2 Minutos</span>
          </div>

          <h2 style="font-size: clamp(1.35rem, 5vw, 1.95rem); font-weight: 900; color: var(--text-main); margin: 0 0 0.6rem 0; line-height: 1.2;">
            O Jeito Mais Fácil de Fazer Compras e Economizar Dinheiro! 🛒✨
          </h2>

          <p style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55; max-width: 620px; margin: 0 auto 1.25rem auto;">
            O <strong>NF Tracker</strong> foi feito para qualquer pessoa da família usar: você planeja o que quer comprar, marca no carrinho, lê o cupom fiscal no final e descobre na hora se economizou ou se passou do orçamento!
          </p>

          <div style="display: flex; justify-content: center; gap: 0.5rem; flex-wrap: wrap;">
            <span style="font-size: 0.75rem; font-weight: 700; background: var(--color-primary-bg); color: var(--color-primary-text); padding: 0.25rem 0.7rem; border-radius: var(--radius-pill); border: 1px solid var(--color-primary-border); display: inline-flex; align-items: center; gap: 0.25rem;">
              <span class="material-symbols-outlined" style="font-size: 14px;">verified_user</span> Seguro e Privado
            </span>
            <span style="font-size: 0.75rem; font-weight: 700; background: var(--color-secondary-bg); color: var(--color-secondary-text); padding: 0.25rem 0.7rem; border-radius: var(--radius-pill); border: 1px solid var(--color-secondary-border); display: inline-flex; align-items: center; gap: 0.25rem;">
              <span class="material-symbols-outlined" style="font-size: 14px;">wifi_off</span> Funciona Sem Internet
            </span>
            <span style="font-size: 0.75rem; font-weight: 700; background: rgba(168, 85, 247, 0.15); color: #A855F7; padding: 0.25rem 0.7rem; border-radius: var(--radius-pill); border: 1px solid rgba(168, 85, 247, 0.3); display: inline-flex; align-items: center; gap: 0.25rem;">
              <span class="material-symbols-outlined" style="font-size: 14px;">group</span> Para Toda a Família
            </span>
          </div>
        </section>

        <!-- Step-by-Step Interactive Guide -->
        <div style="margin-bottom: 2rem;">
          <h3 style="font-size: 1.25rem; font-weight: 800; color: var(--text-main); margin: 0 0 0.35rem 0; display: flex; align-items: center; gap: 0.5rem;">
            <span class="material-symbols-outlined" style="color: var(--color-info, #3B82F6);">auto_awesome</span>
            <span>O Ciclo da Compra Inteligente (Passo a Passo)</span>
          </h3>
          <p style="font-size: 0.84rem; color: var(--text-muted); margin: 0 0 1.25rem 0;">
            Siga estes 5 passos simples para transformar sua ida ao supermercado em uma experiência organizada e sem surpresas na fatura:
          </p>

          <div style="display: flex; flex-direction: column; gap: 1.25rem;">
            
            <!-- Passo 1 -->
            <article class="glass-panel" style="padding: 1.25rem; border-radius: 1rem; border-left: 5px solid #3B82F6; background: var(--bg-surface);">
              <div style="display: flex; align-items: flex-start; gap: 0.85rem;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: #3B82F6; color: #FFFFFF; font-weight: 900; display: flex; align-items: center; justify-content: center; font-size: 1.1rem; flex-shrink: 0;">
                  1
                </div>
                <div style="flex: 1;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                    <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main);">
                      📝 Crie sua Lista de Compras antes de sair
                    </h4>
                    <span style="font-size: 0.68rem; font-weight: 800; background: var(--color-secondary-bg); color: var(--color-secondary-text); padding: 0.15rem 0.55rem; border-radius: var(--radius-pill);">Em Casa</span>
                  </div>
                  <p style="font-size: 0.86rem; color: var(--text-muted); line-height: 1.5; margin: 0.4rem 0 0.75rem 0;">
                    Abra a aba <strong>Listas</strong> e crie uma nova lista (ex: <em>"Feira da Semana"</em> ou <em>"Churrasco de Domingo"</em>). Adicione os produtos e coloque o preço estimado de cada um. O aplicativo calcula automaticamente o <strong>Total Planejado</strong> para você não ter surpresas!
                  </p>
                  
                  <!-- Visual Mini Card Demo -->
                  <div style="background: var(--bg-surface-alt); border: 1px dashed var(--border-color); border-radius: 0.65rem; padding: 0.65rem 0.85rem; display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; font-size: 0.78rem;">
                    <div style="display: flex; align-items: center; gap: 0.4rem;">
                      <span class="material-symbols-outlined" style="font-size: 18px; color: #3B82F6;">playlist_add_check</span>
                      <span style="font-weight: 700; color: var(--text-main);">Lista: Feira da Semana (12 itens)</span>
                    </div>
                    <span class="font-mono" style="font-weight: 800; color: #3B82F6;">Estimado: R$ 150,00</span>
                  </div>
                </div>
              </div>
            </article>

            <!-- Passo 2 -->
            <article class="glass-panel" style="padding: 1.25rem; border-radius: 1rem; border-left: 5px solid #10B981; background: var(--bg-surface);">
              <div style="display: flex; align-items: flex-start; gap: 0.85rem;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: #10B981; color: #FFFFFF; font-weight: 900; display: flex; align-items: center; justify-content: center; font-size: 1.1rem; flex-shrink: 0;">
                  2
                </div>
                <div style="flex: 1;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                    <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main);">
                      🛒 No Mercado: Coloque no carrinho e risque o item
                    </h4>
                    <span style="font-size: 0.68rem; font-weight: 800; background: var(--color-primary-bg); color: var(--color-primary-text); padding: 0.15rem 0.55rem; border-radius: var(--radius-pill);">No Corredor</span>
                  </div>
                  <p style="font-size: 0.86rem; color: var(--text-muted); line-height: 1.5; margin: 0.4rem 0 0.75rem 0;">
                    Conforme for pegando os produtos nas prateleiras, toque no quadradinho de cada item para marcar como pego. O app vai mostrando o total acumulado do carrinho em tempo real!
                  </p>
                  <div style="background: var(--color-primary-bg); border: 1px solid var(--color-primary-border); border-radius: 0.65rem; padding: 0.5rem 0.85rem; font-size: 0.78rem; color: var(--color-primary-text); font-weight: 600; display: flex; align-items: center; gap: 0.35rem;">
                    <span class="material-symbols-outlined" style="font-size: 16px;">family_restroom</span>
                    <span>Dica Família: Se alguém em casa adicionar um produto na lista, ele aparece na hora no seu celular!</span>
                  </div>
                </div>
              </div>
            </article>

            <!-- Passo 3 -->
            <article class="glass-panel" style="padding: 1.25rem; border-radius: 1rem; border-left: 5px solid #F59E0B; background: var(--bg-surface);">
              <div style="display: flex; align-items: flex-start; gap: 0.85rem;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: #F59E0B; color: #FFFFFF; font-weight: 900; display: flex; align-items: center; justify-content: center; font-size: 1.1rem; flex-shrink: 0;">
                  3
                </div>
                <div style="flex: 1;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                    <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main);">
                      🧾 No Caixa: Peça o Cupom Fiscal com QR Code
                    </h4>
                    <span style="font-size: 0.68rem; font-weight: 800; background: var(--color-warning-bg); color: var(--color-warning-text); padding: 0.15rem 0.55rem; border-radius: var(--radius-pill);">No Caixa</span>
                  </div>
                  <p style="font-size: 0.86rem; color: var(--text-muted); line-height: 1.5; margin: 0.4rem 0 0.75rem 0;">
                    Ao pagar suas compras, peça a notinha fiscal eletrônica (NFC-e). Ela tem um <strong>quadradinho preto e branco (QR Code)</strong> impresso no rodapé. É esse código que guarda todos os dados da sua compra!
                  </p>
                  <div style="font-size: 0.78rem; color: var(--color-warning-text); font-style: italic; background: var(--color-warning-bg); border: 1px solid var(--border-color); padding: 0.45rem 0.75rem; border-radius: 0.5rem;">
                    🗣️ O que dizer ao atendente: <em>"Pode imprimir o cupom fiscal com o QR Code, por favor?"</em>
                  </div>
                </div>
              </div>
            </article>

            <!-- Passo 4 -->
            <article class="glass-panel" style="padding: 1.25rem; border-radius: 1rem; border-left: 5px solid #8B5CF6; background: var(--bg-surface);">
              <div style="display: flex; align-items: flex-start; gap: 0.85rem;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: #8B5CF6; color: #FFFFFF; font-weight: 900; display: flex; align-items: center; justify-content: center; font-size: 1.1rem; flex-shrink: 0;">
                  4
                </div>
                <div style="flex: 1;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                    <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main);">
                      📸 Aponte a Câmera e Escaneie em 1 Segundo
                    </h4>
                    <span style="font-size: 0.68rem; font-weight: 800; background: rgba(139, 92, 246, 0.15); color: #A78BFA; padding: 0.15rem 0.55rem; border-radius: var(--radius-pill);">1 Toque</span>
                  </div>
                  <p style="font-size: 0.86rem; color: var(--text-muted); line-height: 1.5; margin: 0.4rem 0 0.75rem 0;">
                    Toque no botão central do <strong>Scanner (câmera)</strong> na parte de baixo do app e aponte para o QR Code da notinha. Em 1 segundo, o NF Tracker lê o nome do supermercado, todos os itens comprados, preços de cada produto, descontos e total pago!
                  </p>
                </div>
              </div>
            </article>

            <!-- Passo 5 -->
            <article class="glass-panel" style="padding: 1.25rem; border-radius: 1rem; border-left: 5px solid #EC4899; background: var(--bg-surface);">
              <div style="display: flex; align-items: flex-start; gap: 0.85rem;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: #EC4899; color: #FFFFFF; font-weight: 900; display: flex; align-items: center; justify-content: center; font-size: 1.1rem; flex-shrink: 0;">
                  5
                </div>
                <div style="flex: 1;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                    <h4 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: var(--text-main);">
                      🎯 Veja a Mágica: Vincule à Lista e Confira o Resultado!
                    </h4>
                    <span style="font-size: 0.68rem; font-weight: 800; background: rgba(236, 72, 153, 0.15); color: #F472B6; padding: 0.15rem 0.55rem; border-radius: var(--radius-pill);">Mágica</span>
                  </div>
                  <p style="font-size: 0.86rem; color: var(--text-muted); line-height: 1.5; margin: 0.4rem 0 0.75rem 0;">
                    O aplicativo percebe a hora da sua compra e sugere automaticamente: <em>"💡 Vincular à lista Feira da Semana?"</em>. Toque em <strong>Vincular</strong> e pronto! Você vê na hora se gastou menos do que planejou (economia!) ou se comprou mais do que devia.
                  </p>
                  
                  <!-- Visual Comparison Demo -->
                  <div style="background: var(--bg-surface-alt); border: 1px solid var(--border-color); border-radius: 0.65rem; padding: 0.75rem; font-size: 0.8rem;">
                    <div style="display: flex; justify-content: space-between; margin-bottom: 0.35rem;">
                      <span style="color: var(--text-muted); font-weight: 600;">📋 Planejado na Lista:</span>
                      <span class="font-mono" style="font-weight: 700; color: var(--text-main);">R$ 150,00</span>
                    </div>
                    <div style="display: flex; justify-content: space-between; margin-bottom: 0.35rem;">
                      <span style="color: var(--color-secondary, #3B82F6); font-weight: 600;">🧾 Total Pago no Caixa:</span>
                      <span class="font-mono font-bold" style="color: var(--color-secondary, #3B82F6);">R$ 138,50</span>
                    </div>
                    <div style="display: flex; justify-content: space-between; padding-top: 0.35rem; border-top: 1px solid var(--border-color);">
                      <span style="color: var(--color-success, #10B981); font-weight: 800;">🎉 Economia Realizada:</span>
                      <span class="font-mono font-bold" style="color: var(--color-success, #10B981);">- R$ 11,50 (-7.7%)</span>
                    </div>
                  </div>
                </div>
              </div>
            </article>

          </div>
        </div>

        <!-- Dicas & Limitações da Fase Beta -->
        <section class="glass-panel mb-lg" style="padding: 1.5rem; border-radius: 1.25rem; border: 1px solid var(--border-color); background: var(--bg-surface);">
          <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.85rem;">
            <span class="material-symbols-outlined" style="color: var(--color-warning, #F59E0B); font-size: 24px;">info</span>
            <h3 style="margin: 0; font-size: 1.15rem; font-weight: 800; color: var(--text-main);">
              Dicas Importantes para Usar no Navegador (Fase Beta)
            </h3>
          </div>

          <p style="font-size: 0.86rem; color: var(--text-muted); line-height: 1.5; margin: 0 0 1rem 0;">
            Como o NF Tracker funciona direto no navegador do seu celular, preparamos algumas dicas para você ter a melhor experiência possível:
          </p>

          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 1rem;">
            
            <!-- Dica 1: Câmera -->
            <div style="background: var(--bg-surface-alt); padding: 0.85rem 1rem; border-radius: 0.75rem; border: 1px solid var(--border-color);">
              <div style="display: flex; align-items: center; gap: 0.35rem; font-weight: 700; font-size: 0.88rem; color: var(--color-secondary, #3B82F6); margin-bottom: 0.25rem;">
                <span class="material-symbols-outlined" style="font-size: 18px;">videocam</span>
                <span>Permissão de Câmera</span>
              </div>
              <p style="font-size: 0.8rem; color: var(--text-muted); margin: 0; line-height: 1.4;">
                Ao abrir o leitor pela primeira vez, o navegador vai perguntar se permite usar a câmera. Clique em <strong>"Permitir"</strong> para escanear os QR Codes.
              </p>
            </div>

            <!-- Dica 2: Estados Atendidos -->
            <div style="background: var(--bg-surface-alt); padding: 0.85rem 1rem; border-radius: 0.75rem; border: 1px solid var(--border-color);">
              <div style="display: flex; align-items: center; gap: 0.35rem; font-weight: 700; font-size: 0.88rem; color: #8B5CF6; margin-bottom: 0.25rem;">
                <span class="material-symbols-outlined" style="font-size: 18px;">receipt</span>
                <span>Cupons Suportados (SEFAZ SP)</span>
              </div>
              <p style="font-size: 0.8rem; color: var(--text-muted); margin: 0; line-height: 1.4;">
                Na fase Beta atual, o leitor é 100% otimizado para notas fiscais do Estado de São Paulo (SEFAZ SP). Se o QR Code estiver amassado, você também pode colar o link da nota manualmente.
              </p>
            </div>

            <!-- Dica 3: Modo Offline -->
            <div style="background: var(--bg-surface-alt); padding: 0.85rem 1rem; border-radius: 0.75rem; border: 1px solid var(--border-color);">
              <div style="display: flex; align-items: center; gap: 0.35rem; font-weight: 700; font-size: 0.88rem; color: var(--color-warning-text, #D97706); margin-bottom: 0.25rem;">
                <span class="material-symbols-outlined" style="font-size: 18px;">cloud_sync</span>
                <span>Sem Sinal no Mercado?</span>
              </div>
              <p style="font-size: 0.8rem; color: var(--text-muted); margin: 0; line-height: 1.4;">
                Se a internet cair dentro do mercado, não se preocupe! Todas as listas e notas ficam salvas na memória do celular e sincronizam com a nuvem assim que você se reconectar.
              </p>
            </div>

          </div>
        </section>

        <!-- Perguntas Frequentes (FAQ) -->
        <section style="margin-bottom: 2.5rem;">
          <h3 style="font-size: 1.2rem; font-weight: 800; color: var(--text-main); margin: 0 0 1rem 0; display: flex; align-items: center; gap: 0.4rem;">
            <span class="material-symbols-outlined" style="color: var(--color-info, #3B82F6);">help</span>
            <span>Perguntas Frequentes</span>
          </h3>

          <div style="display: flex; flex-direction: column; gap: 0.75rem;">
            <details style="background: var(--bg-surface); border: 1px solid var(--border-color); border-radius: 0.75rem; padding: 0.85rem 1rem; cursor: pointer;">
              <summary style="font-weight: 700; font-size: 0.9rem; color: var(--text-main);">
                Minha família pode usar a mesma lista ao mesmo tempo?
              </summary>
              <p style="font-size: 0.84rem; color: var(--text-muted); margin: 0.5rem 0 0 0; line-height: 1.5;">
                Sim! Basta acessar o menu e convidar seus familiares em <strong>Minha Família</strong>. Qualquer pessoa do grupo poderá adicionar itens, marcar produtos no carrinho e conversar pelo chat da lista.
              </p>
            </details>

            <details style="background: var(--bg-surface); border: 1px solid var(--border-color); border-radius: 0.75rem; padding: 0.85rem 1rem; cursor: pointer;">
              <summary style="font-weight: 700; font-size: 0.9rem; color: var(--text-main);">
                Como meus dados e notas ficam salvos?
              </summary>
              <p style="font-size: 0.84rem; color: var(--text-muted); margin: 0.5rem 0 0 0; line-height: 1.5;">
                Suas listas e notas ficam armazenadas com segurança no seu dispositivo e são sincronizadas na nuvem quando você faz login com sua conta.
              </p>
            </details>

            <details style="background: var(--bg-surface); border: 1px solid var(--border-color); border-radius: 0.75rem; padding: 0.85rem 1rem; cursor: pointer;">
              <summary style="font-weight: 700; font-size: 0.9rem; color: var(--text-main);">
                Onde vejo os gráficos e relatórios das minhas compras?
              </summary>
              <p style="font-size: 0.84rem; color: var(--text-muted); margin: 0.5rem 0 0 0; line-height: 1.5;">
                Na aba <strong>Análise</strong> (ícone de gráfico no menu inferior). Lá você encontra o comparativo de <em>Planejado vs. Realizado</em>, histórico de preços de produtos e divisão de compras por categoria!
              </p>
            </details>
          </div>
        </section>

        <!-- Final Call to Action -->
        <section class="glass-panel" style="background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%); color: #FFFFFF; border-radius: 1.25rem; padding: 2rem 1.5rem; text-align: center;">
          <h3 style="font-size: 1.4rem; font-weight: 900; margin: 0 0 0.5rem 0; color: #FFFFFF;">Tudo Pronto para Começar?</h3>
          <p style="font-size: 0.9rem; opacity: 0.9; margin: 0 auto 1.25rem auto; max-width: 480px; line-height: 1.4; color: #FFFFFF;">
            Crie sua primeira lista de compras ou escaneie o cupom fiscal da sua última compra agora mesmo!
          </p>
          <a href="${isAuthenticated ? '#notas' : '#login'}" style="display: inline-flex; align-items: center; gap: 0.4rem; background: #FFFFFF; color: #2563EB; font-weight: 800; font-size: 0.92rem; padding: 0.65rem 1.5rem; border-radius: var(--radius-pill); text-decoration: none; box-shadow: 0 4px 12px rgba(0,0,0,0.25);">
            <span class="material-symbols-outlined" style="font-size: 20px;">rocket_launch</span>
            <span>${isAuthenticated ? 'Ir para Minhas Notas' : 'Entrar no NF Tracker'}</span>
          </a>
        </section>

      </main>
    </div>
  `;
}
